import Tabs from "@/v2-backoffice-client/components/tabs"
import { useUserEmailDuplicateQuery } from "@/v2-backoffice-client/user/emailDuplicate/user.emailDuplicate.query"
import { groupDuplicatesByEmail } from "@/v2-backoffice-client/user/emailDuplicate/userEmailDuplicate.utils"
import { USER_VIEW_EMAIL_DUPLICATES } from "@/v2-backoffice-client/user/user.constants"

// The Users page's Duplicate Emails tab trigger: how many emails more than
// one live user holds right now. Owns its own read of the query, which
// Apollo dedupes against the board's, so the count drops as pairs are
// merged.
function UserEmailDuplicateTabTrigger() {
  const { data, loading } = useUserEmailDuplicateQuery()
  const count = groupDuplicatesByEmail(
    data?.getUserEmailDuplicates ?? [],
  ).length

  return (
    <Tabs.Trigger
      value={USER_VIEW_EMAIL_DUPLICATES}
      iconSrc="users-alt"
      isLoading={loading}
      count={count}
    >
      Duplicate Emails
    </Tabs.Trigger>
  )
}

export default UserEmailDuplicateTabTrigger
